/**
 * Utilitário para capturar estado da seleção para debug
 */

export interface SelectionDump {
  collapsed: boolean;
  text: string;
  startPath: string;
  endPath: string;
  hasSelection: boolean;
  rangeCount: number;
}

/**
 * Captura informações detalhadas sobre a seleção atual
 */
export function dumpSelection(root: HTMLElement): SelectionDump {
  const sel = window.getSelection();
  
  if (!sel || sel.rangeCount === 0) {
    return {
      collapsed: true,
      text: '',
      startPath: '',
      endPath: '',
      hasSelection: false,
      rangeCount: 0
    };
  }

  const range = sel.getRangeAt(0);
  
  return {
    collapsed: range.collapsed,
    text: range.toString(),
    startPath: getNodePath(range.startContainer, root),
    endPath: getNodePath(range.endContainer, root),
    hasSelection: !range.collapsed,
    rangeCount: sel.rangeCount
  };
}

/**
 * Gera um caminho xpath simplificado de um nó até a raiz
 */
function getNodePath(node: Node, root: HTMLElement): string {
  const path: string[] = [];
  let current = node;
  
  while (current && current !== root) {
    if (current.nodeType === Node.ELEMENT_NODE) {
      const element = current as Element;
      const tag = element.tagName.toLowerCase();
      const index = Array.from(element.parentElement?.children || []).indexOf(element);
      path.unshift(`${tag}[${index}]`);
    } else if (current.nodeType === Node.TEXT_NODE) {
      path.unshift(`text()`);
    }
    current = current.parentNode!;
  }
  
  return path.join('/') || 'root';
}